import useSWR from "swr";
import { api } from "../services";
import { PaginatedResult } from "../utils/pagination";

const BASE_URL = "/system-admin/hiringmanager/applicants";

export const useApplicantTracking = (initialParams) => {
  const { type = "" } = initialParams || {};

  const getApplicantTracking = async (pageNumber = 1, pageSize = 10, search = "") => {
    const query = new URLSearchParams();
    query.append("pageNumber", pageNumber);
    query.append("pageSize", pageSize);

    if (search) query.append("search", search);
    if (type && type !== "all") query.append("type", type);

    const response = await api.getPaginated(`${BASE_URL}?${query.toString()}`);
    return new PaginatedResult(response.data, response.pagination);
  };

  const create = async (data) => {
    const applicantTracking = await api.post(BASE_URL, data);
    return applicantTracking;
  };

  const update = async (id, data) => {
    const applicantTracking = await api.patch(`${BASE_URL}/${id}/edit`, data);
    return applicantTracking;
  };

  const updateApplicationStatus = async (id, status, data) => {
    const applicantTracking = await api.patch(`${BASE_URL}/${id}/status?status=${status}`, data);
    return applicantTracking;
  };

  const find = async (query) => {
    const applicantTracking = await api.get(`${BASE_URL}/find?search=${query}`);
    return applicantTracking;
  };

  const getById = async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response;
  };

  return {
    getApplicantTracking,
    updateApplicationStatus,
    create,
    update,
    find,
    getById,
  };
};

export const useApplicantTrackingById = (id) => {
  const { data, isLoading, mutate } = useSWR(id ? `${BASE_URL}/${id}` : null, api.get);

  const remove = async (id) => {
    const applicantTracking = await api.delete(`${BASE_URL}/${id}`);
    return applicantTracking;
  };

  return {
    isLoading: id ? isLoading : false,
    data,
    mutate,
    remove,
  };
};